import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchBar({ value, onChange, placeholder = '搜索 Prompt...' }: SearchBarProps) {
  return (
    <div className="relative">
      <Search className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 w-4 h-4 md:w-5 md:h-5 text-gray-400" />
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-8 md:pl-10 pr-8 md:pr-10 text-sm md:text-base h-9 md:h-10"
      />
      {value && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onChange('')}
          className="absolute right-0.5 md:right-1 top-1/2 -translate-y-1/2 h-6 w-6 md:h-7 md:w-7 p-0"
        >
          <X className="w-3.5 h-3.5 md:w-4 md:h-4" />
        </Button>
      )}
    </div>
  );
}

